/**
 * @generated SignedSource<<96999b115d5a55fb1e5c181bbdc164b6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
export type agileOverviewTwoQuery$variables = {
  limit?: number | null | undefined;
  locale: string;
  urlSlug: string;
};
export type agileOverviewTwoQuery$data = {
  readonly micrositeTopicOverviewCollection: {
    readonly items: ReadonlyArray<{
      readonly _id: string;
      readonly bannerImage: {
        readonly contentType: string | null | undefined;
        readonly description: string | null | undefined;
        readonly fileName: string | null | undefined;
        readonly height: number | null | undefined;
        readonly size: number | null | undefined;
        readonly title: string | null | undefined;
        readonly url: string | null | undefined;
        readonly width: number | null | undefined;
      } | null | undefined;
      readonly description: string | null | undefined;
      readonly featuredContentContainerCollection: {
        readonly items: ReadonlyArray<{
          readonly __typename: "FeaturedVideo";
          readonly callToActionText: string | null | undefined;
          readonly description: string | null | undefined;
          readonly link: string | null | undefined;
          readonly videoName: string | null | undefined;
        } | {
          readonly __typename: "MicrositeArticle";
          readonly articleBanner: {
            readonly contentType: string | null | undefined;
            readonly description: string | null | undefined;
            readonly fileName: string | null | undefined;
            readonly height: number | null | undefined;
            readonly size: number | null | undefined;
            readonly title: string | null | undefined;
            readonly url: string | null | undefined;
            readonly width: number | null | undefined;
          } | null | undefined;
          readonly articleName: string | null | undefined;
          readonly description: string | null | undefined;
          readonly title: string | null | undefined;
          readonly urlSlug: string | null | undefined;
        } | {
          readonly __typename: "ProductFeature";
          readonly callToActionCollection: {
            readonly items: ReadonlyArray<{
              readonly ctaAsset: {
                readonly contentType: string | null | undefined;
                readonly description: string | null | undefined;
                readonly fileName: string | null | undefined;
                readonly height: number | null | undefined;
                readonly size: number | null | undefined;
                readonly title: string | null | undefined;
                readonly url: string | null | undefined;
                readonly width: number | null | undefined;
              } | null | undefined;
              readonly dataBlueprintModule: string | null | undefined;
              readonly productCollection: {
                readonly items: ReadonlyArray<{
                  readonly productLogo: {
                    readonly contentType: string | null | undefined;
                    readonly description: string | null | undefined;
                    readonly fileName: string | null | undefined;
                    readonly height: number | null | undefined;
                    readonly size: number | null | undefined;
                    readonly title: string | null | undefined;
                    readonly url: string | null | undefined;
                    readonly width: number | null | undefined;
                  } | null | undefined;
                  readonly productNameReference: {
                    readonly productName: string | null | undefined;
                  } | null | undefined;
                } | null | undefined>;
              } | null | undefined;
              readonly text: string | null | undefined;
              readonly title: string | null | undefined;
              readonly url: string | null | undefined;
              readonly valueProposition: string | null | undefined;
            } | null | undefined>;
          } | null | undefined;
          readonly description: string | null | undefined;
          readonly name: string | null | undefined;
          readonly slogan: string | null | undefined;
        } | {
          readonly __typename: "Tutorial";
          readonly description: string | null | undefined;
          readonly name: string | null | undefined;
          readonly title: string | null | undefined;
          readonly tutorialBanner: {
            readonly contentType: string | null | undefined;
            readonly description: string | null | undefined;
            readonly fileName: string | null | undefined;
            readonly height: number | null | undefined;
            readonly size: number | null | undefined;
            readonly title: string | null | undefined;
            readonly url: string | null | undefined;
            readonly width: number | null | undefined;
          } | null | undefined;
          readonly urlSlug: string | null | undefined;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        } | null | undefined>;
      } | null | undefined;
      readonly mainCallToAction: {
        readonly asset: {
          readonly contentType: string | null | undefined;
          readonly description: string | null | undefined;
          readonly fileName: string | null | undefined;
          readonly height: number | null | undefined;
          readonly size: number | null | undefined;
          readonly title: string | null | undefined;
          readonly url: string | null | undefined;
          readonly width: number | null | undefined;
        } | null | undefined;
        readonly dataBlueprintModule: string | null | undefined;
        readonly productCollection: {
          readonly items: ReadonlyArray<{
            readonly productLogo: {
              readonly contentType: string | null | undefined;
              readonly description: string | null | undefined;
              readonly fileName: string | null | undefined;
              readonly height: number | null | undefined;
              readonly size: number | null | undefined;
              readonly title: string | null | undefined;
              readonly url: string | null | undefined;
              readonly width: number | null | undefined;
            } | null | undefined;
            readonly productNameReference: {
              readonly productName: string | null | undefined;
            } | null | undefined;
          } | null | undefined>;
        } | null | undefined;
        readonly text: string | null | undefined;
        readonly title: string | null | undefined;
        readonly url: string | null | undefined;
        readonly valueProposition: string | null | undefined;
      } | null | undefined;
      readonly name: string | null | undefined;
      readonly relatedHubCollection: {
        readonly items: ReadonlyArray<{
          readonly description: {
            readonly json: any;
          } | null | undefined;
          readonly shortDescriptionOneLiner: string | null | undefined;
          readonly title: string | null | undefined;
        } | null | undefined>;
      } | null | undefined;
      readonly subtitle: string | null | undefined;
      readonly title: string | null | undefined;
    } | null | undefined>;
  } | null | undefined;
};
export type agileOverviewTwoQuery = {
  response: agileOverviewTwoQuery$data;
  variables: agileOverviewTwoQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": 1,
  "kind": "LocalArgument",
  "name": "limit"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "locale"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "urlSlug"
},
v3 = [
  {
    "kind": "Variable",
    "name": "limit",
    "variableName": "limit"
  },
  {
    "kind": "Variable",
    "name": "locale",
    "variableName": "locale"
  },
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "urlSlug",
        "variableName": "urlSlug"
      }
    ],
    "kind": "ObjectValue",
    "name": "where"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
},
v5 = {
  "alias": "name",
  "args": null,
  "kind": "ScalarField",
  "name": "topicNameExternal",
  "storageKey": null
},
v6 = {
  "alias": "title",
  "args": null,
  "kind": "ScalarField",
  "name": "topicTitle",
  "storageKey": null
},
v7 = {
  "alias": "subtitle",
  "args": null,
  "kind": "ScalarField",
  "name": "topicSubtitle",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v9 = [
  (v8/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "width",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "height",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "size",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fileName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "contentType",
    "storageKey": null
  }
],
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "Asset",
  "kind": "LinkedField",
  "name": "bannerImage",
  "plural": false,
  "selections": (v9/*: any*/),
  "storageKey": null
},
v11 = {
  "alias": "title",
  "args": null,
  "kind": "ScalarField",
  "name": "ctaTitleExternal",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "valueProposition",
  "storageKey": null
},
v13 = {
  "alias": "text",
  "args": null,
  "kind": "ScalarField",
  "name": "ctaText",
  "storageKey": null
},
v14 = {
  "alias": "url",
  "args": null,
  "kind": "ScalarField",
  "name": "ctaUrl",
  "storageKey": null
},
v15 = [
  {
    "kind": "Literal",
    "name": "limit",
    "value": 1
  }
],
v16 = {
  "alias": null,
  "args": (v15/*: any*/),
  "concreteType": "CallToActionProductCollection",
  "kind": "LinkedField",
  "name": "productCollection",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductListing",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductName",
          "kind": "LinkedField",
          "name": "productNameReference",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "productName",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": "productLogo",
          "args": null,
          "concreteType": "Asset",
          "kind": "LinkedField",
          "name": "icon",
          "plural": false,
          "selections": (v9/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "productCollection(limit:1)"
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dataBlueprintModule",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "CallToAction",
  "kind": "LinkedField",
  "name": "mainCallToAction",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    (v12/*: any*/),
    (v13/*: any*/),
    (v14/*: any*/),
    {
      "alias": "asset",
      "args": null,
      "concreteType": "Asset",
      "kind": "LinkedField",
      "name": "ctaAsset",
      "plural": false,
      "selections": (v9/*: any*/),
      "storageKey": null
    },
    (v16/*: any*/),
    (v17/*: any*/)
  ],
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v20 = {
  "alias": "articleName",
  "args": null,
  "kind": "ScalarField",
  "name": "articleNameExternal",
  "storageKey": null
},
v21 = {
  "alias": "title",
  "args": null,
  "kind": "ScalarField",
  "name": "articleTitle",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlSlug",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "Asset",
  "kind": "LinkedField",
  "name": "articleBanner",
  "plural": false,
  "selections": (v9/*: any*/),
  "storageKey": null
},
v24 = {
  "alias": "name",
  "args": null,
  "kind": "ScalarField",
  "name": "tutorialNameExternal",
  "storageKey": null
},
v25 = {
  "alias": "title",
  "args": null,
  "kind": "ScalarField",
  "name": "tutorialTitle",
  "storageKey": null
},
v26 = {
  "alias": "description",
  "args": null,
  "kind": "ScalarField",
  "name": "tutorialDescription",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "Asset",
  "kind": "LinkedField",
  "name": "tutorialBanner",
  "plural": false,
  "selections": (v9/*: any*/),
  "storageKey": null
},
v28 = {
  "alias": "name",
  "args": null,
  "kind": "ScalarField",
  "name": "featureNameExternal",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slogan",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": (v15/*: any*/),
  "concreteType": "ProductFeatureCallToActionCollection",
  "kind": "LinkedField",
  "name": "callToActionCollection",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CallToAction",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        (v11/*: any*/),
        (v12/*: any*/),
        (v13/*: any*/),
        (v14/*: any*/),
        (v16/*: any*/),
        (v17/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Asset",
          "kind": "LinkedField",
          "name": "ctaAsset",
          "plural": false,
          "selections": (v9/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "callToActionCollection(limit:1)"
},
v31 = {
  "alias": "videoName",
  "args": null,
  "kind": "ScalarField",
  "name": "featuredVideoTitleExternal",
  "storageKey": null
},
v32 = {
  "alias": "description",
  "args": null,
  "kind": "ScalarField",
  "name": "videoDescription",
  "storageKey": null
},
v33 = {
  "alias": "link",
  "args": null,
  "kind": "ScalarField",
  "name": "videoLink",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "callToActionText",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": (v15/*: any*/),
  "concreteType": "MicrositeTopicOverviewRelatedHubCollection",
  "kind": "LinkedField",
  "name": "relatedHubCollection",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TaxonomyContentHub",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": "title",
          "args": null,
          "kind": "ScalarField",
          "name": "contentHubTitleExternal",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "shortDescriptionOneLiner",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TaxonomyContentHubDescription",
          "kind": "LinkedField",
          "name": "description",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "json",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "relatedHubCollection(limit:1)"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "agileOverviewTwoQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "MicrositeTopicOverviewCollection",
        "kind": "LinkedField",
        "name": "micrositeTopicOverviewCollection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MicrositeTopicOverview",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v10/*: any*/),
              (v18/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MicrositeTopicOverviewFeaturedContentContainerCollection",
                "kind": "LinkedField",
                "name": "featuredContentContainerCollection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v19/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v8/*: any*/),
                          (v22/*: any*/),
                          (v23/*: any*/)
                        ],
                        "type": "MicrositeArticle",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v19/*: any*/),
                          (v24/*: any*/),
                          (v25/*: any*/),
                          (v26/*: any*/),
                          (v27/*: any*/),
                          (v22/*: any*/)
                        ],
                        "type": "Tutorial",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v19/*: any*/),
                          (v28/*: any*/),
                          (v29/*: any*/),
                          (v8/*: any*/),
                          (v30/*: any*/)
                        ],
                        "type": "ProductFeature",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v19/*: any*/),
                          (v31/*: any*/),
                          (v32/*: any*/),
                          (v33/*: any*/),
                          (v34/*: any*/)
                        ],
                        "type": "FeaturedVideo",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v35/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "agileOverviewTwoQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "MicrositeTopicOverviewCollection",
        "kind": "LinkedField",
        "name": "micrositeTopicOverviewCollection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MicrositeTopicOverview",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v10/*: any*/),
              (v18/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MicrositeTopicOverviewFeaturedContentContainerCollection",
                "kind": "LinkedField",
                "name": "featuredContentContainerCollection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                      (v19/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v8/*: any*/),
                          (v22/*: any*/),
                          (v23/*: any*/)
                        ],
                        "type": "MicrositeArticle",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v24/*: any*/),
                          (v25/*: any*/),
                          (v26/*: any*/),
                          (v27/*: any*/),
                          (v22/*: any*/)
                        ],
                        "type": "Tutorial",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v28/*: any*/),
                          (v29/*: any*/),
                          (v8/*: any*/),
                          (v30/*: any*/)
                        ],
                        "type": "ProductFeature",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v31/*: any*/),
                          (v32/*: any*/),
                          (v33/*: any*/),
                          (v34/*: any*/)
                        ],
                        "type": "FeaturedVideo",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v35/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "16839b26e04e283c4fee7e20f65e0ae1",
    "id": null,
    "metadata": {},
    "name": "agileOverviewTwoQuery",
    "operationKind": "query",
    "text": "query agileOverviewTwoQuery(\n  $limit: Int = 1\n  $urlSlug: String!\n  $locale: String!\n) {\n  micrositeTopicOverviewCollection(limit: $limit, where: {urlSlug: $urlSlug}, locale: $locale) {\n    items {\n      _id\n      name: topicNameExternal\n      title: topicTitle\n      subtitle: topicSubtitle\n      description\n      bannerImage {\n        description\n        title\n        url\n        width\n        height\n        size\n        fileName\n        contentType\n      }\n      mainCallToAction {\n        title: ctaTitleExternal\n        valueProposition\n        text: ctaText\n        url: ctaUrl\n        asset: ctaAsset {\n          description\n          title\n          url\n          width\n          height\n          size\n          fileName\n          contentType\n        }\n        productCollection(limit: 1) {\n          items {\n            productNameReference {\n              productName\n            }\n            productLogo: icon {\n              description\n              title\n              url\n              width\n              height\n              size\n              fileName\n              contentType\n            }\n          }\n        }\n        dataBlueprintModule\n      }\n      featuredContentContainerCollection {\n        items {\n          __typename\n          ... on MicrositeArticle {\n            __typename\n            articleName: articleNameExternal\n            title: articleTitle\n            description\n            urlSlug\n            articleBanner {\n              description\n              title\n              url\n              width\n              height\n              size\n              fileName\n              contentType\n            }\n          }\n          ... on Tutorial {\n            __typename\n            name: tutorialNameExternal\n            title: tutorialTitle\n            description: tutorialDescription\n            tutorialBanner {\n              description\n              title\n              url\n              width\n              height\n              size\n              fileName\n              contentType\n            }\n            urlSlug\n          }\n          ... on ProductFeature {\n            __typename\n            name: featureNameExternal\n            slogan\n            description\n            callToActionCollection(limit: 1) {\n              items {\n                title: ctaTitleExternal\n                valueProposition\n                text: ctaText\n                url: ctaUrl\n                productCollection(limit: 1) {\n                  items {\n                    productNameReference {\n                      productName\n                    }\n                    productLogo: icon {\n                      description\n                      title\n                      url\n                      width\n                      height\n                      size\n                      fileName\n                      contentType\n                    }\n                  }\n                }\n                dataBlueprintModule\n                ctaAsset {\n                  description\n                  title\n                  url\n                  width\n                  height\n                  size\n                  fileName\n                  contentType\n                }\n              }\n            }\n          }\n          ... on FeaturedVideo {\n            __typename\n            videoName: featuredVideoTitleExternal\n            description: videoDescription\n            link: videoLink\n            callToActionText\n          }\n        }\n      }\n      relatedHubCollection(limit: 1) {\n        items {\n          title: contentHubTitleExternal\n          shortDescriptionOneLiner\n          description {\n            json\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "552765973dd4dce2d7916642df1959cd";

export default node;
